import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import CircleButton from "../../commons/CircleButton";
import { hideModal } from "../../../../usecases/commons/hide-modal";
import { translate as t } from "../../../../infrastructure/translate/localization";
import { uploadEmployees } from "../../../../usecases/employees/upload-employees";
import { saveEmployee } from "../../../../usecases/employees/save-employee";
import { saveSessionBulkEmployee } from "../../../../usecases/employees/save-session-bulk-employee";
import { downloadNovationContracts } from "../../../../usecases/employees/download-novation-contracts";
import { translateEmployeeProperties } from "../../../../infrastructure/translate/translateEmployeeProperties";
import CobeeSelect from "../../cobeeSelect/CobeeSelect";
import CobeeInput from "../../commons/cobeeInput/CobeeInput";

import "./show-detail-employee.scss";

class ShowDetailEmployee extends Component {
  constructor(props) {
    super(props);
    const { taxRegimes } = this.props;
    this.state = {
      isNewUser: true,
      id: "",
      internalId: "",
      costCenter: "",
      payrollCompany: "",
      name: "",
      surname: "",
      firstSurname: "",
      secondSurname: "",
      email: "",
      modelId: "",
      grossSalary: undefined,
      legalId: "",
      state: "",
      taxRegime: taxRegimes[0],
      hiringDate: "",
    };
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
    const { employee } = this.props;
    if (employee.id !== undefined) {
      this.setState({
        isNewUser: false,
        ...employee,
        secondSurname: employee.secondSurname || "",
        grossSalary: undefined,
        hiringDate: employee.hiringDate
          ? moment(employee.hiringDate).format("YYYY-MM-DD")
          : employee.hiringDate,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
    this.onClose();
  }

  handleAccept = () => {
    const employee = { ...this.state };
    this.saveChangesOfEmployee(employee);
    this.onClose();
  };

  saveChangesOfEmployee = (currentEmployee) => {
    const { grossSalary, firstSurname, secondSurname } = this.state;
    const { currentPage, editType } = this.props;
    const saveChanges = {
      newEmployee: (employee) =>
        uploadEmployees([
          {
            ...employee,
            surname: `${firstSurname} ${secondSurname || ""}`,
          },
        ]),
      editEmployee: (employee) =>
        saveEmployee(
          {
            ...employee,
            grossSalary: grossSalary === undefined ? "REDACTED" : grossSalary,
          },
          currentPage
        ),
      editMassiveEmployee: (employee) =>
        saveSessionBulkEmployee({
          ...employee,
          grossSalary: grossSalary === undefined ? "REDACTED" : grossSalary,
        }),
    };

    return saveChanges[editType](currentEmployee);
  };

  changeSelect = (modelId) => this.setState({ modelId });

  handleOnSubmit = (e) => {
    e.preventDefault();
    this.handleAccept();
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.handleAccept();
    }
  };

  onClose = () => {
    const { onFinish } = this.props;
    if (onFinish) onFinish();
    hideModal();
  };

  render() {
    const {
      isNewUser,
      internalId,
      costCenter,
      payrollCompany,
      name,
      surname,
      firstSurname,
      secondSurname,
      email,
      grossSalary,
      legalId,
      modelId,
      taxRegime,
      hiringDate,
    } = this.state;

    const { employee, warnings, errors, benefitModels, taxRegimes } =
      this.props;

    return (
      <div className="modal-container">
        <CircleButton
          className="primary close-modal"
          icon="times"
          handlerClick={() => {
            this.onClose();
          }}
        />
        <div className="modal-content">
          <div className="profile">
            <form onSubmit={(e) => this.handleOnSubmit(e)}>
              <div className="cob-row">
                <CobeeInput
                  labelText={t("common-messages.internal-id")}
                  changeText={(e) =>
                    this.setState({ internalId: e.target.value })
                  }
                  value={internalId}
                />

                <CobeeInput
                  labelText={t("common-messages.cost-center")}
                  changeText={(e) =>
                    this.setState({ costCenter: e.target.value })
                  }
                  value={costCenter}
                />

                <CobeeInput
                  labelText={t("common-messages.company-name-employer")}
                  changeText={(e) =>
                    this.setState({ payrollCompany: e.target.value })
                  }
                  value={payrollCompany}
                />

                <CobeeInput
                  labelText={`${t("common-messages.name")}*`}
                  changeText={(e) => this.setState({ name: e.target.value })}
                  value={name}
                  required
                />

                {isNewUser && (
                  <CobeeInput
                    labelText={`${t("common-messages.surname-first")}*`}
                    changeText={(e) =>
                      this.setState({ firstSurname: e.target.value })
                    }
                    value={firstSurname}
                    required
                  />
                )}

                {isNewUser && (
                  <CobeeInput
                    labelText={t("common-messages.surname-second")}
                    changeText={(e) =>
                      this.setState({ secondSurname: e.target.value })
                    }
                    value={secondSurname}
                  />
                )}

                {!isNewUser && (
                  <CobeeInput
                    labelText={t("common-messages.surnames")}
                    changeText={(e) =>
                      this.setState({ surname: e.target.value })
                    }
                    value={surname}
                    required
                  />
                )}
              </div>

              <div className="separate-line" />

              <div className="cob-row">
                <CobeeInput
                  inputType="email"
                  labelText={`${t("common-messages.email")}*`}
                  changeText={(e) =>
                    this.setState({ email: e.target.value.toLowerCase() })
                  }
                  value={email}
                  required
                />

                <CobeeInput
                  labelText={`${t("common-messages.legal-id")}*`}
                  changeText={(e) => this.setState({ legalId: e.target.value })}
                  value={legalId}
                  required
                />

                <div className="cob-input-group">
                  <span className="input-label">
                    {t("upload-employees-section.annual-gross-salary")}*
                    <span className="salary-tooltip">
                      <FontAwesomeIcon
                        data-tip={t(
                          "upload-employees-section.annual-gross-salary-tip"
                        )}
                        icon="info-circle"
                      />
                      <ReactTooltip
                        className="tooltipMessage"
                        place="top"
                        effect="solid"
                        type="light"
                      />
                    </span>
                  </span>

                  <input
                    pattern="\d+"
                    type="text"
                    placeholder={
                      isNewUser
                        ? t("upload-employees-section.annual-gross-salary")
                        : t("upload-employees-section.hidden")
                    }
                    onChange={(e) =>
                      this.setState({ grossSalary: e.target.value })
                    }
                    value={grossSalary}
                    required={isNewUser}
                  />
                </div>

                <CobeeInput
                  inputType="date"
                  labelText={t("upload-employees-section.hiring-date")}
                  changeText={(e) =>
                    this.setState({ hiringDate: e.target.value })
                  }
                  value={hiringDate || ""}
                />
              </div>

              <div className="separate-line" />

              <div className="cob-row">
                <div className="cob-input-group">
                  <span className="input-label">
                    {t("common-messages.benefit-model")}*
                  </span>
                  <CobeeSelect
                    handledChange={(e) => this.changeSelect(e.target.value)}
                    defaultValue={t("employees-section.select-model")}
                    value={modelId}
                    listItems={benefitModels}
                  />
                </div>

                <div className="cob-input-group">
                  <span className="input-label">
                    {t("employees-section.tax-regime")}*
                  </span>
                  <CobeeSelect
                    handledChange={(e) =>
                      this.setState({ taxRegime: e.target.value })
                    }
                    defaultValue={t("employees-section.select-tax-regime")}
                    value={taxRegime}
                    listItems={taxRegimes.map((id) => ({
                      id,
                      name: translateEmployeeProperties("taxRegime", id),
                    }))}
                  />
                </div>
              </div>

              <div className="cob-row">
                {errors && (
                  <p className="text-error">
                    {translateEmployeeProperties("errors", errors)}
                  </p>
                )}
                {warnings && (
                  <p className="text-warning">
                    {translateEmployeeProperties("errors", warnings)}
                  </p>
                )}
              </div>
              <div className="separate-line" />

              <div className="cob-btn-group right-group">
                <button
                  type="button"
                  className="cob-link"
                  disabled={!employee.termsAndConditions}
                  onClick={() =>
                    downloadNovationContracts(
                      employee.termsAndConditions.idNovationContract,
                      employee.legalId
                    )
                  }
                >
                  <FontAwesomeIcon icon="download" />{" "}
                  {t("upload-employees-section.download-contract")}
                </button>
              </div>

              <div className="cob-btn-group center-group">
                <button type="submit" className="btn">
                  {isNewUser ? t("actions.create") : t("actions.save")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

ShowDetailEmployee.defaultProps = {
  editType: "editEmployee",
  errors: undefined,
  warnings: undefined,
  currentPage: 1,
};

ShowDetailEmployee.propTypes = {
  employee: PropTypes.object.isRequired,
  editType: PropTypes.oneOf([
    "newEmployee",
    "editEmployee",
    "editMassiveEmployee",
  ]),
  taxRegimes: PropTypes.array.isRequired,
  errors: PropTypes.string,
  warnings: PropTypes.string,
  benefitModels: PropTypes.array.isRequired,
  onFinish: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
};

export default ShowDetailEmployee;
